import React, { useState } from 'react';
import styled from 'styled-components';
import { Droppable } from 'react-beautiful-dnd';
import { useTemplate } from '../../context/TemplateContext';
import EmailElement from './EmailElement';

const Editor = ({ onSelectElement, selectedElement }) => {
  const { template } = useTemplate();
  const [viewMode, setViewMode] = useState('desktop'); // 'desktop' or 'mobile'

  return (
    <EditorContainer>
      <EditorHeader>
        <ViewToggle>
          <ViewButton 
            active={viewMode === 'desktop'}
            onClick={() => setViewMode('desktop')}
          >
            Desktop
          </ViewButton>
          <ViewButton 
            active={viewMode === 'mobile'}
            onClick={() => setViewMode('mobile')}
          >
            Mobile
          </ViewButton>
        </ViewToggle>
      </EditorHeader>
      <EditorCanvas style={{ backgroundColor: template.styles.backgroundColor }}>
        <EmailContainer 
          className={viewMode === 'mobile' ? 'mobile-view' : ''}
          style={{ 
            width: viewMode === 'mobile' ? '320px' : template.styles.width,
            fontFamily: template.styles.fontFamily,
            color: template.styles.color
          }}>
          <Droppable droppableId="editor">
              {(provided) => (
                <DropArea
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                >
                  {template.elements.length === 0 ? (
                    <EmptyState>
                      <i className="fas fa-envelope"></i>
                      <p>Add elements to build your email template</p>
                    </EmptyState>
                  ) : (
                    template.elements.map((element, index) => (
                      <EmailElement
                        key={element.id}
                        element={element}
                        index={index}
                        onClick={() => onSelectElement(element)}
                        isSelected={selectedElement && selectedElement.id === element.id}
                      />
                    ))
                  )}
                  {provided.placeholder}
                </DropArea>
              )}
            </Droppable>
        </EmailContainer>
      </EditorCanvas>
    </EditorContainer>
  );
};

const EditorContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

const EditorHeader = styled.div`
  padding: 10px 20px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: center;
`;

const ViewToggle = styled.div`
  display: flex;
  background-color: #f5f5f5;
  border-radius: 4px;
  overflow: hidden;
`;

const ViewButton = styled.button`
  padding: 8px 16px;
  border: none;
  background-color: ${props => props.active ? '#5876ff' : 'transparent'};
  color: ${props => props.active ? '#ffffff' : '#333333'};
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: ${props => props.active ? '#5876ff' : '#e0e0e0'};
  }
`;

const EditorCanvas = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  justify-content: center;
  background-color: #f0f0f0;
`;

const EmailContainer = styled.div`
  background-color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  min-height: 800px;
  transition: width 0.3s ease;
  
  &.mobile-view {
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
  }
`;

const DropArea = styled.div`
  min-height: 800px;
`;

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 800px;
  color: #999;
  
  i {
    font-size: 48px;
    margin-bottom: 20px;
    color: #ccc;
  }
  
  p {
    font-size: 16px;
  }
`;

export default Editor;
